import * as React from 'react';
import { Grid, Typography, IconButton, /* IconButton */ } from '@material-ui/core';
import RegionwiseResponseComponent from './RegionwiseResponseComponent';
import KeyboardBackspaceIcon from '@material-ui/icons/KeyboardBackspace';

export default class AdminResponseComponent extends React.Component<any, any> {

    state = {
        isAdmin: false,
        dashobardData: {},
        surveys: [],
        selectedSurveyId: '',
        showReminder: false
    };

    constructor(props: any) {
        super(props);

        this.handleYearChange = this.handleYearChange.bind(this);
        this.handleReminderConfig = this.handleReminderConfig.bind(this);
        this.onDialogClose = this.onDialogClose.bind(this);
        this.saveReminderConfig = this.saveReminderConfig.bind(this);
        this.gotoResponses = this.gotoResponses.bind(this);
    }

    handleYearChange(event: any) {
        this.setState({ selectedSurveyId: event.target.value });

        this.state.isAdmin ? this.props.userAdminDashboard(event.target.value) : this.props.userRegionalAdminDashboard(event.target.value)
    }

    handleReminderConfig = () => {
        this.setState({ showReminder: true });
    }

    onDialogClose = () => {
        this.setState({ showReminder: false })
    }

    saveReminderConfig = (data: any) => {
        this.setState({ showReminder: false })
        this.props.saveReminderConfig(data)
    }

    gotoResponses() {
        this.props.gotoResponses(true);
    }

    render() {
        const dashboardData: any = this.props.dashboardData;
        const surveys: any = this.props.surveys ? this.props.surveys : [];
        const selectedSurvey = this.props.selectedSurvey ? this.props.selectedSurvey : ''

        return (
            <div>
                <div className="pageHeading">
                    <Grid container={true} spacing={8}>
                        <Grid item={true} xs={6}>
                            <div className="pageTitleSection">
                                <IconButton className="backButton" color="inherit" aria-label="Open drawer" onClick={this.gotoResponses}>
                                    <KeyboardBackspaceIcon />
                                </IconButton>
                                <Typography component="h2" variant="title" align="left" gutterBottom={true} className="pageTitle">
                                    {selectedSurvey && (selectedSurvey.title + " " + selectedSurvey.year)}
                                </Typography>
                            </div>
                        </Grid>
                    </Grid>
                </div>

                <div className="pageContent">
                    <div className="contentSection">
                        <RegionwiseResponseComponent
                            dashboardData={dashboardData}
                            surveys={surveys}
                            selectedSurvey={selectedSurvey}
                            countryModuleDetails={this.props.countryModuleDetails}
                            isAdmin={this.props.isAdmin}
                        />
                    </div>
                </div>
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/AdminDashboardResponse/AdminResponseComponent.tsx